const a = {
  "aws-player": "aws-player",
  "aws-player__controls--hidden": "aws-player__controls--hidden",
  "aws-player--fullscreen-videoloop": "aws-player--fullscreen-videoloop",
  "aws-player--fullscreen": "aws-player--fullscreen",
  "aws-player--cover": "aws-player--cover",
  "aws-player--contain": "aws-player--contain"
};
export {
  a as default
};
